{
  "id": "campaign-013",
  "name": "Lucky Acre",
  "seed": "campaign:13",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "HHHHH.......",
    "HHHHH.......",
    "_____.......",
    "............",
    ".g..#.......",
    ".....,......",
    "____________",
    "...h........",
    "............",
    "........#...",
    ".....*......",
    "....***.....",
    ".....*......",
    "S....B......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 7,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "repair",
      "x": 8,
      "y": 13
    }
  ],
  "generatorVersion": 3,
  "level": 13,
  "biome": "backyard",
  "par": {
    "reel": 4786,
    "push": 3985,
    "selfPropelled": 3678,
    "tractor": 3605,
    "zeroTurn": 2708,
    "fairway": 1876
  },
  "routeTries": {
    "par": {
      "reel": 24,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 2,
      "fairway": 7
    }
  }
}
